import http from '@/http'

const PATH = '/customers'

function getPath (customerId) {
    return `${PATH}/${customerId}/services`
}

export default {
    /**
     * @param {{customerId: number, params: {}}} data
     * @returns {Promise<void>}
     */
    async listServices ({customerId, params}) {
        try {
            const response = await http.get(getPath(customerId), {params})
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    async listServicesFull ({customerId}) {
        try {
            const response = await http.get(`${getPath(customerId)}/all`)
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    async enableService ({customerId, params}) {
        try {
            const response = await http.post(`${getPath(customerId)}/enable`,  {...params})
            
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    async showService ({customerId, productId}) {
        try {
            const response = await http.get(`${getPath(customerId)}/${productId}`)
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    async disableService ({customerId, id}) {
        try {
            const response = await http.put(`${getPath(customerId)}/${id}/disable`)
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    }
}
